import React, { Component } from 'react';

export default class FieldLabel extends Component {
  render() {
    const { children, viewMode, required } = this.props;
    const props = { className: 'ui form' };
    const labelProps = viewMode ? { style: { color: '#004a23' } } : {};
    const showRequired = !viewMode && required ? 'required' : '';
    const wrappedChild = (
      <div className={`${showRequired} field`}>
        <label {...labelProps}>{children}</label>
      </div>
    );
    return React.createElement('div', props, wrappedChild);
  }
}
